import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const ClubEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;

  const defaultClub = {
    name: "",
    email: "",
    contact_person: "",
    contact_email: "",
    address: "",
    phone: "",
    iban: "",
    bic: "",
    logo: "",
    second_contact_person: "",
    second_contact_phone: "",
    second_contact_email: "",
    location_of_signing: "",
    date_of_signing: "",
    signed_by: ""
  };

  const [club, setClub] = useState(isEditMode ? null : defaultClub);
  const [loading, setLoading] = useState(isEditMode);

  useEffect(() => {
    if (isEditMode) {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clubs/${id}`)
        .then((res) => res.json())
        .then((data) => {
          setClub(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching club:", err);
          setLoading(false);
        });
    }
  }, [id, isEditMode]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setClub((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formatDate = (value) => {
    if (!value) return "";
    if (typeof value === "string" && value.includes("T")) {
      return value.split("T")[0]; // trim time
    }
    return value;
  };

  const handleSave = async () => {
  const {
    name,
    email,
    contact_person,
    contact_email,
    address,
    phone,
    iban,
    bic,
    logo,
    second_contact_person = "",
    second_contact_phone = "",
    second_contact_email = "",
    location_of_signing = "",
    date_of_signing = "",
    signed_by = ""
  } = club;

  const updatePayload = {
    name,
    email,
    contact_person,
    contact_email,
    address,
    phone,
    iban,
    bic,
    logo,
    second_contact_person,
    second_contact_phone,
    second_contact_email,
    location_of_signing,
    date_of_signing,
    signed_by
  };

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clubs${isEditMode ? `/${id}` : ""}`, {
      method: isEditMode ? "PUT" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatePayload),
    });

    if (response.ok) {
      alert(`✅ Club ${isEditMode ? "updated" : "created"} successfully.`);
      navigate("/admin/clubs");
    } else {
      const data = await response.json();
      alert(`❌ Failed: ${data.message || "Save error"}`);
    }
  } catch (err) {
    console.error("Save error:", err);
    alert("❌ Error saving club.");
  }
};



  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow">
      <h2 className="text-3xl font-bold mb-6 text-center">
        {isEditMode ? "Edit Club" : "Add New Club"}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block mb-1 font-medium">Name</label>
          <input name="name" value={club.name || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
        </div>
        <div>
          <label className="block mb-1 font-medium">Email</label>
          <input name="email" value={club.email || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
        </div>
      </div>

      <fieldset className="border p-4 rounded mb-6">
        <legend className="text-lg font-semibold">Club Information</legend>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block mb-1 font-medium">Address</label>
            <input name="address" value={club.address || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Primary Contact Person</label>
            <input name="contact_person" value={club.contact_person || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Email of Primary Contact</label>
            <input name="contact_email" value={club.contact_email || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Phone Number</label>
            <input name="phone" value={club.phone || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">IBAN</label>
            <input name="iban" value={club.iban || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">BIC</label>
            <input name="bic" value={club.bic || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Secondary Contact Person (optional)</label>
            <input name="second_contact_person" value={club.second_contact_person || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Phone Number of Secondary Contact (optional)</label>
            <input name="second_contact_phone" value={club.second_contact_phone || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Email of Secondary Contact (optional)</label>
            <input name="second_contact_email" value={club.second_contact_email || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
        </div>
      </fieldset>

      <fieldset className="border p-4 rounded mb-6">
        <legend className="text-lg font-semibold">Signing Information</legend>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block mb-1 font-medium">Place of Signing</label>
            <input name="location_of_signing" value={club.location_of_signing || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Date of Signing</label>
            <input name="date_of_signing" type="date"   value={formatDate(club.date_of_signing)} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
          <div>
            <label className="block mb-1 font-medium">Signed By (Board Member or Authorized Person)</label>
            <input name="signed_by" value={club.signed_by || ""} onChange={handleInputChange} className="w-full p-2 border rounded" />
          </div>
        </div>
      </fieldset>

      
      <button onClick={handleSave} className="w-full md:w-auto bg-green-600 text-white font-semibold px-6 py-3 rounded hover:bg-green-700 transition">
        {isEditMode ? "Save Changes" : "Create Club"}
      </button>
    </div>
  );
};

export default ClubEditPage;
